import { CurrencyPipe, NgOptimizedImage } from '@angular/common';
import { ChangeDetectionStrategy, Component, computed, inject, model } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { NgxTolgeeModule } from '@tolgee/ngx';

import { CartItem, GiftCartItem, GiftFormat } from '../../../../../core/model/cart/cart-item.model';
import { emulateClick } from '../../core/a11y';
import { ProductService } from '../../shared/services/product.service';
import { SiteService } from '../../shared/services/site.service';

@Component({
  changeDetection: ChangeDetectionStrategy.OnPush,
  selector: 'app-cart-item-line',
  imports: [
    NgOptimizedImage,
    NgxTolgeeModule,
    FormsModule,
    ReactiveFormsModule,
    CurrencyPipe
  ],
  templateUrl: './cart-item-line.component.html'
})

export class CartItemLineComponent {
  readonly emulateClick = emulateClick;
  readonly GiftFormat = GiftFormat;
  productService = inject(ProductService);
  siteService = inject(SiteService);
  item = model.required<{ item: CartItem, quantity: number }>();
  asGift = computed(() => {
    const { item } = this.item();
    return item instanceof GiftCartItem ? item as GiftCartItem : null
  });
  product = computed(() => this.productService.get(this.item().item.product))
}
